// extracted by mini-css-extract-plugin
export default {"container":"confirm-message-content_container__Wnm6A","title":"confirm-message-content_title__yEKsK","message":"confirm-message-content_message__PHZQO"};